module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-bottom-15ab35565e0ade62469f9fd67ea0040e625ffb761f7b6d185ef2c352aaacfe95.svg";